import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';

const ReportArdilaPdf = async (data) => {

    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        },
        CantoraOne: {
            bold: 'CantoraOne-Regular.ttf'
        }
    };

    console.log(data);

    const fecha = moment(data.fecha + " " + data.hora).format('lll');

    const contentPDF = [{ 
        margin: [0, 150, 0, 10],
        columns: [
            {
                ul: [
                    { text: 'Historia Clinica No. ' + data.documentNumber, style: 'textStyle', listType: 'none' },
                    { text: data.names, bold: true, style: 'textStyle', listType: 'none' },
                    { text: 'No. Documento: ' + data.documentNumber, style: 'textStyle', listType: 'none' },
                    { text: 'Edad: ' + data.age, style: 'textStyle', listType: 'none' },
                    { text: 'Remitido Por: ' + data.remitente, style: 'textStyle', listType: 'none' }
                ]
            },
            {
                ul: [
                    { text: ' ', style: 'textStyle', listType: 'none' },
                    { text: 'Dirección: ' + data.address, style: 'textStyle', listType: 'none' },
                    { text: 'Telefono: ' + data.telephone, style: 'textStyle', listType: 'none' },
                    { text: 'Ocupacion: '+ data.ocupation, style: 'textStyle', listType: 'none' },
                    { text: 'Entidad: ' + data.plan, style: 'textStyle', listType: 'none' },
                ]
            },
        ],
        // optional space between columns
        columnGap: 10
    },
    {
        // auto-sized columns have their widths based on their content                                       
        margin: [0, 5, 0, 5],
        layout: {
            defaultBorder: false,
        },
        table: {
            headerRows: 1,
            widths: [90, '*', 200],
            heights: 20,
            body: [
                [{ text: 'Tipo de Atención ', style: 'textStyle', border: [false, true, false, false] },
                { text: 'Consulta', bold: true, style: 'textStyle', border: [false, true, false, false] },
                { text: 'Fecha: ' + fecha, style: 'textStyle', border: [false, true, false, false] }],
                [{ text: 'Firma Digital ', style: 'textStyle', border: [false, true, false, false] },
                { text: 'SANDRA ARDILA', bold: true, style: 'textStyle', border: [false, true, false, false] },
                { text: '', style: 'textStyle', border: [false, true, false, false] }],
            ]
        },
    }];

    if (data.motivo_consulta != undefined && data.motivo_consulta != null && data.motivo_consulta != "") {
        contentPDF.push({
            text: 'MOTIVO DE CONSULTA:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
        {
            text: data.motivo_consulta, style: 'textStyle', margin: [0, 0, 0, 10]
        });
    }

    if (data.encuesta_inventario != undefined && data.encuesta_inventario != null && data.encuesta_inventario != "") {
        contentPDF.push({
            text: 'ENCUESTA INVENTARIO DE DISCAPACIDAD POR VÉRTIGO (DHI)', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
        {
            text: data.encuesta_inventario, style: 'textStyle', margin: [0, 0, 0, 10]
        });
    }

    if (data.pruebas_equilibrio != undefined && data.pruebas_equilibrio != null && data.pruebas_equilibrio != "") {
        contentPDF.push({
            text: 'PRUEBAS DE EQUILIBRIO ESTÁTICO Y DINÁMICO:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
        {
            text: data.pruebas_equilibrio, style: 'textStyle', margin: [0, 0, 0, 10]
        });
    }

    if (data.nistagmo_espontanoeo != undefined && data.nistagmo_espontanoeo != null && data.nistagmo_espontanoeo != "") {
        contentPDF.push({
            text: 'NISTAGMO ESPONTÁNEO:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
        {
            text: data.nistagmo_espontanoeo, style: 'textStyle', margin: [0, 0, 0, 10]
        });
    }

    if (data.maniobra_hallpike != undefined && data.maniobra_hallpike != null && data.maniobra_hallpike != "") {
        contentPDF.push({
            text: 'MANIOBRA DE DIX HALLPIKE:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
        {
            text: data.maniobra_hallpike, style: 'textStyle', margin: [0, 0, 0, 10]
        });
    }

    if (data.test_agudeza != undefined && data.test_agudeza != null && data.test_agudeza != "") {
        contentPDF.push({
            text: 'TEST DE AGUDEZA VISUAL:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
        {
            text: data.test_agudeza, style: 'textStyle', margin: [0, 0, 0, 10]
        });
    }

    if (data.conclusion != undefined && data.conclusion != null && data.conclusion != "") {
        contentPDF.push({
            text: 'CONCLUSIONESL:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
        {
            text: data.conclusion, style: 'textStyle', margin: [0, 0, 0, 10]
        });
    }

    if (data.recomendaciones != undefined && data.recomendaciones != null && data.recomendaciones != "") {
        contentPDF.push({
            text: 'RECOMENDACIONES:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
        {
            text: data.recomendaciones, style: 'textStyle', margin: [0, 0, 0, 10]
        });
    }

    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        content: contentPDF,
        styles: {
            head: {
                fontSize: 7,
                bold: true,
                alignment: 'left',
                font: 'OpenSans'
            },
           
            textStyle: {
                fontSize: 9,
                font: 'OpenSans'
            },            
            foter: {
                alignment: 'center',
                fontSize: 8,
                font: 'OpenSans'
            },
        }
    }

    pdfMake.createPdf(documentDefinition).open();

}

export default ReportArdilaPdf